import type { CookieAttributes } from 'js-cookie';
import Cookies from 'js-cookie';
import { useCallback } from "react";

type UseCookiesReturn = {
  getCookie: (name: string) => string | undefined;
  setCookie: (name: string, value: string, options?: CookieAttributes) => void;
  removeCookie: (name: string) => void;
};

const useCookies = (): UseCookiesReturn => {
  // Get a cookie
  const getCookie = useCallback((name: string): string | undefined => {
    return Cookies.get(name);
  }, []);

  // Set a cookie
  const setCookie = useCallback(
    (name: string, value: string, options?: CookieAttributes): void => {
      Cookies.set(name, value, {
        secure: true,
        sameSite: "Strict",
        ...options,
      });
    },
    []
  );

  // Remove a cookie
  const removeCookie = useCallback((name: string): void => {
    Cookies.remove(name);
  }, []);

  return { getCookie, setCookie, removeCookie };
};

export default useCookies;
